window.SHIPPING_RATES = {
      1: {
        MQP: { 1: 25.75, 2: 51.50 },
        QP:  { 1: 27.25, 2: 54.50 },
        HP:  { 1: 28.75, 2: 57.50 }
    },
      2: {
        MQP: { 1: 31.50, 2: 63.00 },
        QP:  { 1: 32.00, 2: 64.00 },
        HP:  { 1: 32.50, 2: 65.00 }
    },
      3: {
        MQP: { 1: 34.70, 2: 69.40 },
        QP:  { 1: 36.20, 2: 72.40 },
        HP:  { 1: 37.70, 2: 75.40 }
    },
      4: {
        MQP: { 1: 36.20, 2: 72.40 },
        QP:  { 1: 38.20, 2: 76.40 },
        HP:  { 1: 39.70, 2: 79.40 }
    },
      5: {
        MQP: { 1: 38.20, 2: 76.40 },
        QP:  { 1: 40.20, 2: 80.40 },
        HP:  { 1: 41.20, 2: 82.40 }
    },
      6: {
        MQP: { 1: 41.45, 2: 82.90 },
        QP:  { 1: 42.45, 2: 84.90 },
        HP:  { 1: 44.45, 2: 88.90 }
    },
      7: {
        MQP: { 1: 44.95, 2: 89.90 },
        QP:  { 1: 46.45, 2: 92.90 },
        HP:  { 1: 46.95, 2: 93.90 }
    },
      8: {
        MQP: { 1: 48.95, 2: 97.90 },
        QP:  { 1: 51.45, 2: 102.90 },
        HP:  { 1: 53.45, 2: 106.90 }
    },
      9: {
        MQP: { 1: 60.95, 2: 121.90 },
        QP:  { 1: 62.95, 2: 125.90 },
        HP:  { 1: 63.95, 2: 127.90 }
    },
      10: {
        MQP: { 1: 64.95, 2: 129.90 },
        QP:  { 1: 66.95, 2: 133.90 },
        HP:  { 1: 70.95, 2: 141.90 }
    },
      11: {
        MQP: { 1: 70.45, 2: 140.90 },
        QP:  { 1: 72.95, 2: 145.90 },
        HP:  { 1: 72.95, 2: 145.90 }
    },
      12: {
        MQP: { 1: 76.45, 2: 152.90 },
        QP:  { 1: 78.95, 2: 157.90 },
        HP:  { 1: 78.95, 2: 157.90 }
    },
      13: {
        MQP: { 1: 51.95, 2: 103.90 },
        QP:  { 1: 54.45, 2: 108.90 },
        HP:  { 1: 55.45, 2: 110.90 }
    },
      14: {
        MQP: { 1: 43.45, 2: 86.90 },
        QP:  { 1: 45.45, 2: 90.90 },
        HP:  { 1: 45.95, 2: 91.90 }
    },
      15: {
        MQP: { 1: 47.95, 2: 95.90 },
        QP:  { 1: 50.45, 2: 100.90 },
        HP:  { 1: 51.45, 2: 102.90 }
    },
      16: {
        MQP: { 1: 74.90, 2: 149.80 },
        QP:  { 1: 76.90, 2: 153.80 },
        HP:  { 1: 79.90, 2: 159.80 }
    },
      17: {
        MQP: { 1: 82.30, 2: 164.60 },
        QP:  { 1: 85.30, 2: 170.60 },
        HP:  { 1: 94.80, 2: 189.60 }
    },
      18: {
        MQP: { 1: 88.50, 2: 177.00 },
        QP:  { 1: 91.50, 2: 183.00 },
        HP:  { 1: 96.50, 2: 193.00 }
    },
      19: {
        MQP: { 1: 109.95, 2: 219.90 },
        QP:  { 1: 109.95, 2: 219.90 },
        HP:  { 1: 111.95, 2: 223.90 }
    },
      20: {
        MQP: { 1: 138.45, 2: 276.90 },
        QP:  { 1: 138.45, 2: 276.90 },
        HP:  { 1: 140.45, 2: 280.90 }
    },
      21: {
        MQP: { 1: 122.95, 2: 245.90 },
        QP:  { 1: 122.95, 2: 245.90 },
        HP:  { 1: 124.95, 2: 249.90 }
    },
      22: {
        MQP: { 1: 151.45, 2: 302.90 },
        QP:  { 1: 151.45, 2: 302.90 },
        HP:  { 1: 153.45, 2: 306.90 }
    },
      23: {
        MQP: { 1: 105.45, 2: 210.90 },
        QP:  { 1: 105.45, 2: 210.90 },
        HP:  { 1: 106.95, 2: 213.90 }
    },
      24: {
        MQP: { 1: 145.45, 2: 290.90 },
        QP:  { 1: 145.45, 2: 290.90 },
        HP:  { 1: 151.45, 2: 302.90 }
    },
      25: {
        MQP: { 1: 70.95, 2: 141.90 },
        QP:  { 1: 70.95, 2: 141.90 },
        HP:  { 1: 70.95, 2: 141.90 }
    },
      26: {
        MQP: { 1: 128.45, 2: 256.90 },
        QP:  { 1: 128.45, 2: 256.90 },
        HP:  { 1: 128.45, 2: 256.90 }
    },
      27: {
        MQP: { 1: 124.20, 2: 248.40 },
        QP:  { 1: 124.20, 2: 248.40 },
        HP:  { 1: 148.20, 2: 296.40 }
    },
      28: {
        MQP: { 1: 246.95, 2: 493.90 },
        QP:  { 1: 246.95, 2: 493.90 },
        HP:  { 1: 246.95, 2: 493.90 }
    },
      29: {
        MQP: { 1: 55.45, 2: 110.90 },
        QP:  { 1: 56.95, 2: 113.90 },
        HP:  { 1: 57.95, 2: 115.90 }
    },
      30: {
        MQP: { 1: 59.45, 2: 118.90 },
        QP:  { 1: 61.95, 2: 123.90 },
        HP:  { 1: 61.95, 2: 123.90 }
    },
      31: {
        MQP: { 1: 79.20, 2: 158.40 },
        QP:  { 1: 81.20, 2: 162.40 },
        HP:  { 1: 84.20, 2: 168.40 }
    },
      32: {
        MQP: { 1: 34.45, 2: 68.90 },
        QP:  { 1: 34.95, 2: 69.90 },
        HP:  { 1: 35.45, 2: 70.90 }
    },
      33: {
        MQP: { 1: 35.45, 2: 70.90 },
        QP:  { 1: 36.45, 2: 72.90 },
        HP:  { 1: 37.45, 2: 74.90 }
    },
    34: {
        MQP: { 1: 37.45, 2: 74.90 },
        QP:  { 1: 38.45, 2: 76.90 },
        HP:  { 1: 40.45, 2: 80.90 }
    },
    35: {
        MQP: { 1: 42.45, 2: 84.90 },
        QP:  { 1: 43.95, 2: 87.90 },
        HP:  { 1: 44.45, 2: 88.90 }
    },
}